import styled from 'styled-components';

export const ImageGalleryWrapper = styled.div`
  ${({isSeo}) =>
    isSeo &&
    `
  max-width: 120rem;
  width: 100%;
  margin: 0 auto;
  padding: 3.5rem 0;
  padding-bottom: 0;
`}
`;

export const AltAccoCaptivateBannerContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Backdrop = styled.div`
  background: rgba(0, 0, 0, 0);
  width: 100%;
`;
